"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.infraredPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var infraredPalette = {
  infrared10: '#FDEAE0',
  infrared30: '#FFD9C4',
  infrared60: '#FFB88D',
  infrared: '#FF9151',
  infraredDark: '#E25F12',
  infraredDarkest: '#AA3F00'
};
exports.infraredPalette = infraredPalette;